import styled from "styled-components"
import Card from "@irati/ui/src/Layout/Card"

export default styled(Card)`
  > *,
  > * > * {
    display: inline-block;
    margin-bottom: ${({theme}) => theme.spacing.four};
    &:last-child {
      margin-bottom: 0;
    }
  }
`
